import React from "react";
import { Box, Typography, Container, Paper } from "@mui/material";
// import LoyaltySettings from "../components/LoyaltySettings";
import CloverOAuthSettings from "../components/CloverOAuthSettings";

const SettingsPage = () => {
  return (
    <Container sx={{ mt: 4 }}>
      <Paper sx={{ p: 3, boxShadow: 3, borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom>
          Settings
        </Typography>

        {/* <Box sx={{ mt: 3 }}>
          <LoyaltySettings />
        </Box> */}

        <Box sx={{ mt: 3 }}>
          <CloverOAuthSettings />
        </Box>
      </Paper>
    </Container>
  );
};

export default SettingsPage;
